import { render, staticRenderFns } from "./joinBillDialog.vue?vue&type=template&id=16258da6&"
import script from "./joinBillDialog.vue?vue&type=script&lang=js&"
export * from "./joinBillDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16258da6')) {
      api.createRecord('16258da6', component.options)
    } else {
      api.reload('16258da6', component.options)
    }
    module.hot.accept("./joinBillDialog.vue?vue&type=template&id=16258da6&", function () {
      api.rerender('16258da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/BillingNative/joinBillDialog.vue"
export default component.exports